export default function withClusterFeatureFunction(mapController) {
	mapController.setClusterFeaturePropertiesFunction = function setClusterFeaturePropertiesFunction(clusterFeaturePropertiesFunction) {
		mapController._clusterFeaturePropertiesFunction = clusterFeaturePropertiesFunction;
	};

	mapController.getClusterFeaturePropertiesFunction = function getClusterFeaturePropertiesFunction() {
		return mapController._clusterFeaturePropertiesFunction;
	};
}
